import { PaymentMethodCreatePage } from '@/features/payment-method/pages/PaymentMethodCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/payment-method/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["payment_methods.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PaymentMethodCreatePage,
})
